export enum ClientDonorType {
    Individual = 0,
    Organization = 1
}
